import { render } from "./CheckupCardLarge.vue?vue&type=template&id=622b6158&scoped=true"
import script from "./CheckupCardLarge.vue?vue&type=script&lang=js"
export * from "./CheckupCardLarge.vue?vue&type=script&lang=js"

import "./CheckupCardLarge.vue?vue&type=style&index=0&id=622b6158&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b6158"]])

export default __exports__